import { AGENT_IMAGES_URL } from "../../constants/url";

// Server status -> label shown in the UI.
const STATUS_LABELS = {
  active: "Active",
  idle: "Idle",
  offline: "Offline",
};

export const STATUS_COLORS = {
  Active: "#4CAF50",
  Idle: "#F5A623",
  Offline: "#9E9E9E",
  "No Data": "#9E9E9E",
};

export const formatLastUpdate = (iso, now = Date.now()) => {
  if (!iso) return "Never";
  const diff = Math.max(0, Math.floor((now - new Date(iso).getTime()) / 1000));
  if (diff < 60) return `${diff} sec ago`;
  if (diff < 3600) return `${Math.floor(diff / 60)} min ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)} hr ago`;
  return `${Math.floor(diff / 86400)} d ago`;
};

const hasCoords = (lat, lng) =>
  typeof lat === "number" && typeof lng === "number" && !(lat === 0 && lng === 0);

// Merge a REST row or SignalR payload (same field names) into the UI staff shape.
export const toStaff = (api, prev = {}) => {
  const hasLocation = hasCoords(api.lat, api.lng);
  const name = [api.firstName ?? prev.firstName, api.lastName ?? prev.lastName]
    .filter(Boolean)
    .join(" ");
  return {
    ...prev,
    id: api.agentId,
    firstName: api.firstName ?? prev.firstName,
    lastName: api.lastName ?? prev.lastName,
    name: name || prev.name || `Agent ${api.agentId}`,
    agentImg: api.agentImage
      ? `${AGENT_IMAGES_URL}${api.agentImage}`
      : api.agentImage === undefined
        ? prev.agentImg
        : null,
    status: STATUS_LABELS[api.status] || (hasLocation ? "Offline" : "No Data"),
    speedKmh: api.speedKmh ?? null,
    batteryPct: api.batteryPct ?? null,
    speed: api.speedKmh != null ? `${Math.round(api.speedKmh)} km/h` : "-",
    battery: api.batteryPct != null ? `${api.batteryPct}%` : "-",
    lastUpdateAt: api.lastUpdate ?? null,
    liveLocation: hasLocation ? { lat: api.lat, lng: api.lng } : prev.liveLocation ?? null,
  };
};

export const toHistoryPath = (trail = []) =>
  trail
    .filter((p) => hasCoords(p.lat, p.lng))
    .map((p) => ({
      lat: p.lat,
      lng: p.lng,
      time: new Date(p.recorded_at).toTimeString().slice(0, 5), // local HH:MM
    }));

// Local-day boundaries as ISO-ish strings the API accepts.
export const dayRange = (dateStr) => ({
  from: `${dateStr}T00:00:00`,
  to: `${dateStr}T23:59:59`,
});

export const todayStr = () => {
  const d = new Date();
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
};
